<template>
  <div class="language-selector">
    <q-select
      v-model="currentLocale"
      :options="localeOptions"
      dense
      outlined
      emit-value
      map-options
      label="Language"
      @update:model-value="changeLocale"
    >
      <template v-slot:prepend>
        <q-icon name="language" />
      </template>
      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps">
          <q-item-section avatar>
            <q-icon :name="getLocaleIcon(scope.opt.value)" />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ scope.opt.label }}</q-item-label>
            <q-item-label caption>{{ scope.opt.nativeName }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { SUPPORTED_LOCALES, setLocale } from '../i18n';

const { locale } = useI18n();
const currentLocale = ref(locale.value);

const localeOptions = computed(() => {
  return Object.entries(SUPPORTED_LOCALES).map(([value, { name, nativeName }]) => ({
    value,
    label: name,
    nativeName
  }));
});

const getLocaleIcon = (locale) => {
  const icons = {
    en: 'flag_us',
    ar: 'flag_sa',
    es: 'flag_es',
    fr: 'flag_fr',
    de: 'flag_de',
    zh: 'flag_cn'
  };
  return icons[locale] || 'language';
};

const changeLocale = (value) => {
  setLocale(value);
};
</script>

<style scoped>
.language-selector {
  min-width: 120px;
  margin-left: auto;
  margin-right: 10px;
}
</style>